module.exports = __webpack_public_path__ + "static/img_1171-fbf52f4ceb7ea05e7d9d6f62e1662a0d.webp";